import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

const SafeIcon = ({ icon: Icon, className }) => {
  if (!Icon) {
    return <FiAlertCircle className={className} />;
  }
  return <Icon className={className} />;
};

export default SafeIcon;